<script setup lang="ts">
import type { MenuRoute } from '@/types/interface'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useRoute } from 'vue-router'
import { usePermissionStore, useSettingStore } from '@/store'

import LSideNav from './SideNav.vue'

const route = useRoute()
const permissionStore = usePermissionStore()
const settingStore = useSettingStore()
const { routers: menuRouters } = storeToRefs(permissionStore)

const sideMenu = computed(() => {
  const { layout, splitMenu } = settingStore
  let newMenuRouters = menuRouters.value as Array<MenuRoute>
  if (layout === 'mix' && splitMenu) {
    newMenuRouters.forEach((menu) => {
      if (route.path.indexOf(menu.path) === 0) {
        newMenuRouters = menu.children.map(subMenu => ({ ...subMenu, path: `${menu.path}/${subMenu.path}` }))
      }
    })
  }
  return newMenuRouters
})
</script>

<template>
  <LSideNav
    v-if="settingStore.showSidebar"
    :show-logo="settingStore.showSidebarLogo"
    :layout="settingStore.layout"
    :is-fixed="settingStore.isSidebarFixed"
    :menu="sideMenu"
    :theme="settingStore.displaySideMode"
    :is-compact="settingStore.isSidebarCompact"
  />
</template>
